export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_PAGE_INDEX = 0;
export const DEFAULT_SORT_FIELD = 'date';
export const DEFAULT_SORT_DIRECTION: 'asc' | 'desc' = 'asc';

export const COLUMN_FIELDS = {
  EMPLOYEE: 'employeeLastName',
  DATE: 'date',
  START_WORK: 'startWork',
  END_WORK: 'endWork',
  START_BREAK: 'startBreak',
  END_BREAK: 'endBreak',
  EFFECTIVE_TOTAL: 'effectiveTotalMinutes',
  DEVIATION: 'deviationMinutes',
  REGISTRATION_STATUS: 'timeRegistrationStatus',
  COST_CENTER: 'costCenterId',
} as const;

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
